import React from "react";

import { useAppStore } from "@store/appStateStore";
import { updateTransaction, fetchTransactions } from "@services/api";

import { Transaction } from "@local-types/transaction/tableRow";

import AgGridTable from "@components/shared/AgGridTable";
import { ActionCellRenderer } from "@components/shared/actionColumn";

import { getColumnDefs } from "./columnDefs";

const TransactionsTable: React.FC<{
  customTransactions?: Transaction[];
  customColumnDefs?: any[];
}> = ({ customTransactions = null, customColumnDefs = null }) => {
  const { transactions, setTransactions } = useAppStore();

  const handleCellValueChanged = async (params: any) => {
    const { data, colDef, newValue, oldValue } = params;
    if (newValue === oldValue) return;

    const field = colDef.field;
    const updates: any = {};
    updates[field] = newValue;

    try {
      await updateTransaction(data.id, updates);

      const updatedTransactions = await fetchTransactions();
      setTransactions(updatedTransactions);
    } catch (error) {
      console.error("Ошибка:", error);
      alert("Ошибка обновления транзакции");
    }
  };

  const handleDeleteSuccess = async () => {
    try {
      const transactions = await fetchTransactions();
      setTransactions(transactions);
    } catch (error) {
      console.error("Ошибка загрузки транзакций после удаления:", error);
      alert("Ошибка обновления списка транзакций");
    }
  };

  const columnDefs = getColumnDefs(handleCellValueChanged, handleDeleteSuccess);

  return (
    <AgGridTable
      title="Транзакции"
      rowData={customTransactions || transactions}
      columnDefs={customColumnDefs || columnDefs}
      height={600}
      components={{ ActionCellRenderer: ActionCellRenderer }}
    />
  );
};

export default TransactionsTable;
